import { render, staticRenderFns } from "./BaseTablePagination.vue?vue&type=template&id=e5d1d7c6&scoped=true"
import script from "./BaseTablePagination.vue?vue&type=script&lang=js"
export * from "./BaseTablePagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5d1d7c6",
  null
  
)

export default component.exports